import styled from "@emotion/styled";

export const SettingsSectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: flex-start;
  gap: 24px;
  overflow: hidden;
  width: 100%;
  max-width: 784px;
  padding: ${({ theme }) => `0 ${theme.spacing[7]} ${theme.spacing[5]} ${theme.spacing[7]}`};

  @container mds-panel (max-width: 750px) {
    padding: ${({ theme }) => `0 ${theme.spacing[4]} ${theme.spacing[5]} ${theme.spacing[4]}`};
  }
`;
